<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @opentable="opentable" @del="delall" @save="save"
                    @exps="exp" @imp="imp" ref="SetBtn"></buttonlist>
        <!-- 功能按钮 -->
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <div style="margin-top: 2px">
                    <el-button type="primary" size="mini" @click="setRoutingRoad" :disabled="!btn.setroutingroad">{{$t('getapi[7932]')}}</el-button>
                </div>
                <!--<wTable id="xpane-0" ref="singleTable"
                        queryData="ENGROUTINGMASTERViewInfo"
                        :data="datajson" :loading="loading" :header="tableHeader"
                        :option="tableOption" @edits="edits" @rowdblclick="openEdit" @contextmenu.prevent.native="openMenu($event)"></wTable>-->
                <div id="xpane-0">
                <vTable
                        :data="datajson"
                        :loading="loading"
                        queryData="ENGROUTINGMASTERViewInfo"
                        :filter_language="['Direct_Stuff_Move_flag','version_status','enable_flag','ce_flag']"
                        :filter_date="['EFFECT_DATE','INVALID_DATE']"
                        :header="tableHeader"
                        :height="tableH"
                        ref="singleTable"
                        @edits="edits"
                        @rowdblclick="openEdit"
                        @handleSelectionChange="handleSelectionChangeview"
                        @handleSelectionChangeAll="handleSelectionChangeAllview"
                        @handleSelectionChangeEnd="handleSelectionChangeview"
                ></vTable>
                </div>
            </li>

            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;z-index: 88">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="width:1100px;min-width: 1100px;overflow:auto">
                    <table>
                        <tr>
                            <td colspan="3">
                                <span>{{ $t('getapi[203]') }}</span>
                                <el-checkbox
                                        true-label="1"
                                        false-label="0"
                                        v-model="formInline.version_status"
                                        :checked="formInline.version_status == '1' ? true : false"
                                        @change="status"
                                        lable
                                        :disabled="!btn.available "
                                ></el-checkbox>
                                <span>{{$t('getapi[555]')}}</span>
                                <el-checkbox @change="enable" v-model="formInline.enable_flag"
                                             :disabled="!btn.frozen"></el-checkbox>
                                <span>{{ $t('getapi[8047]') }}</span>
                                <el-checkbox :disabled="true" v-model="formInline.ce_flag" :checked="formInline.ce_flag == 1 ? true : false"
                                             true-label=1 false-label=0></el-checkbox>
                            </td>
                            <td style="width:120px;min-width:120px;">
                                <span>{{$t('getapi[553]')}}</span>
                                <el-checkbox
                                        true-label="1"
                                        false-label="0"
                                        @change="movef"
                                        :disabled="!canmove || !page.move_direction"
                                        v-model="formInline.direct_stuff_move_flag"
                                        :checked="formInline.direct_stuff_move_flag == 1 ? true : false"
                                ></el-checkbox>
                            </td>
                            <td style="width: 80px">
                                <span>{{ $t('getapi[554]') }}</span>
                            </td>
                            <td style="width: 120px;min-width: 120px">
                                <el-select
                                        filterable
                                        v-model="formInline.move_direction"
                                        :placeholder="$t('getapi[554]')"
                                        :disabled="formInline.direct_stuff_move_flag != 1 || !page.move_direction"
                                        style="width: 100%"
                                        size="mini"
                                >
                                    <el-option
                                            v-for="items in ProPositionList"
                                            :key="items.shop_position_code"
                                            :label="items.shop_position_name"
                                            :value="items.shop_position_code"
                                    ></el-option>
                                </el-select>
                            </td>
                            <td style="width: 100px"><span>{{ $t('getapi[6382]') }}</span></td>
                            <td style="width: 120px;min-width: 120px"><el-input v-model="formInline.tag_single" size="mini"></el-input></td>
                            <td style="width: 100px"><span>{{ $t('getapi[6383]') }}</span></td>
                            <td style="width: 120px;min-width: 120px"><el-input v-model="formInline.tag_packag" size="mini"></el-input></td>
                        </tr>
                        <tr>
                            <td style="width: 80px"><span>{{ $t('getapi[112]') }}</span></td>
                            <td style="width: 120px;min-width: 120px">
                                <routejump :urlNo="12">
                                    <el-input v-model="formInline.part_code" :placeholder="$t('getapi[112]')"
                                              v-show="addoredit == 1" class="mcolor" size="mini" readonly>
                                        <i class="el-icon-edit el-input__icon" slot="suffix" @click="doTheThing"></i>
                                    </el-input>
                                    <el-input v-model="formInline.part_code" :placeholder="$t('getapi[112]')"
                                              v-show="addoredit != 1" :readonly="true" class="readO" size="mini"></el-input>
                                </routejump>
                            </td>
                            <td style="width: 80px"><span>{{ $t('getapi[149]') }}</span></td>
                            <td  style="width: 120px;min-width: 120px">
                                <el-input v-model="formInline.part_version" :placeholder="$t('getapi[149]')" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[116]') }}</td>
                            <td>
                                <el-input v-model="formInline.part_name" :placeholder="$t('getapi[116]')" :readonly="true" class="readO"
                                           size="mini"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[547]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.routing_version" :placeholder="$t('getapi[547]')"
                                          :readonly="addoredit != 1" :class="{'readO':addoredit != 1}" size="mini"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[12574]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.cargoposition_code" :placeholder="$t('getapi[12574]')"
                                          :disabled="true" size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[548]') }}</span></td>
                            <td>
                                <el-date-picker
                                        v-model="formInline.effect_date"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        :placeholder="$t('getapi[548]')"
                                        :readonly="formInline.version_status == 1 && addoredit != 1"
                                        :class="[formInline.version_status == 1 && addoredit != 1?'readO':'mcolor']"
                                        size="mini"
                                        style="width:100%"
                                ></el-date-picker>
                            </td>
                            <td><span>{{ $t('getapi[410]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.create_person" :placeholder="$t('getapi[410]')" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[733]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.modify_person" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[550]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.audit_person" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[12645]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.tool"
                                          size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[549]') }}</span></td>
                            <td>
                                <el-date-picker
                                        v-model="formInline.invalid_date"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        :placeholder="$t('getapi[549]')"
                                        :readonly="formInline.version_status == 1 && addoredit != 1"
                                        :class="{'readO':formInline.version_status == 1 && addoredit != 1}"
                                        size="mini"
                                        style="width:100%"
                                ></el-date-picker>
                            </td>
                            <td><span>{{ $t('getapi[409]') }}</span></td>
                            <td><el-input v-model="formInline.create_time" class="readO"
                                          size="mini"></el-input></td>
                            <td><span>{{ $t('getapi[734]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.modify_time" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[732]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.audit_time" class="readO" size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[143]') }}</span></td>
                            <td colspan="7">
                                <el-input type="textarea" v-model="formInline.remark" :placeholder="$t('getapi[143]')"
                                           size="mini"
                                          :readonly="formInline.version_status == 1 && addoredit != 1" :class="{'readO':formInline.version_status == 1 && addoredit != 1}"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
                <!--<div class="box">
                    &lt;!&ndash; 编辑弹框 &ndash;&gt;
                    <div class="bbl">
                        <label>{{ $t('getapi[203]') }}</label>
                        <el-checkbox
                                true-label="1"
                                false-label="0"
                                v-model="formInline.version_status"
                                :checked="formInline.version_status == '1' ? true : false"
                                @change="status"
                                lable
                                :disabled="!btn.available "
                        ></el-checkbox>
                        <label>{{ $t('getapi[555]') }}</label>
                        <el-checkbox @change="enable" v-model="formInline.enable_flag"
                                     :disabled="!btn.frozen"></el-checkbox>
                        <label>{{ $t('getapi[553]') }}</label>
                        <el-checkbox
                                true-label="1"
                                false-label="0"
                                @change="movef"
                                :disabled="!canmove"
                                v-model="formInline.direct_stuff_move_flag"
                                :checked="formInline.direct_stuff_move_flag == 1 ? true : false"
                        ></el-checkbox>
                        <span>{{ $t('getapi[554]') }}</span>
                        <el-select
                                filterable
                                v-model="formInline.move_direction"
                                :placeholder="$t('getapi[554]')"
                                :disabled="formInline.direct_stuff_move_flag != 1"
                                style="width: 100px;"
                                size="mini"
                        >
                            <el-option
                                    v-for="items in ProPositionList"
                                    :key="items.shop_position_code"
                                    :label="items.shop_position_name"
                                    :value="items.shop_position_code"
                            ></el-option>
                        </el-select>

                        <span>{{ $t('getapi[6382]') }}</span>
                        <el-input v-model="formInline.tag_single" style="width: 130px;" size="mini"></el-input>

                        <span>{{ $t('getapi[6383]') }}</span>
                        <el-input v-model="formInline.tag_packag" style="width: 130px;" size="mini"></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[112]') }}</span>
                        <el-input v-model="formInline.part_code" :placeholder="$t('getapi[112]')"
                                  v-show="addoredit == 1" style="width: 130px;" class="mcolor" size="mini" readonly>
                            <i class="el-icon-edit el-input__icon" slot="suffix" @click="doTheThing"></i>
                        </el-input>

                        <el-input v-model="formInline.part_code" :placeholder="$t('getapi[112]')"
                                  v-show="addoredit != 1" :readonly="true" class="readO" style="width: 130px;" size="mini"></el-input>

                        <span>{{ $t('getapi[149]') }}</span>
                        <el-input v-model="formInline.part_version" :placeholder="$t('getapi[149]')" :readonly="true" class="readO"
                                  style="width: 130px;" size="mini"></el-input>

                        <span>{{ $t('getapi[116]') }}</span>
                        <el-input v-model="formInline.part_name" :placeholder="$t('getapi[116]')" :readonly="true" class="readO"
                                  style="width: 130px;" size="mini"></el-input>
                        <span>{{ $t('getapi[8047]') }}</span>
                         <el-checkbox :disabled="true" v-model="formInline.ce_flag" :checked="formInline.ce_flag == 1 ? true : false"
                         true-label=1 false-label=0></el-checkbox>
                        
                        <span>{{ $t('getapi[547]') }}</span>
                        <el-input v-model="formInline.routing_version" :placeholder="$t('getapi[547]')"
                                  :readonly="addoredit != 1" :class="{'readO':addoredit != 1}" style="width: 100px;" size="mini"></el-input>
                                  <span>{{ $t('getapi[12574]') }}</span>
                        <el-input v-model="formInline.cargoposition_code" :placeholder="$t('getapi[12574]')"
                                  :disabled="true" style="width: 100px;" size="mini"></el-input>
                    </div>
                    <div class="bbl">
                        
                        <span>{{ $t('getapi[548]') }}</span>
                        <el-date-picker
                                v-model="formInline.effect_date"
                                type="date"
                                value-format="yyyy-MM-dd"
                                :placeholder="$t('getapi[548]')"
                                :readonly="formInline.version_status == 1 && addoredit != 1"
                                :class="[formInline.version_status == 1 && addoredit != 1?'readO':'mcolor']"
                                style="width: 130px;"
                                size="mini"
                        ></el-date-picker>

                        <span>{{ $t('getapi[410]') }}</span>
                        <el-input v-model="formInline.create_person" :placeholder="$t('getapi[410]')" :readonly="true" class="readO"
                                  style="width:130px;" size="mini"></el-input>
                        <span>{{ $t('getapi[733]') }}</span>
                        <el-input v-model="formInline.modify_person" :readonly="true" class="readO" style="width: 130px;"
                                  size="mini"></el-input>
                        <span>{{ $t('getapi[550]') }}</span>
                        <el-input v-model="formInline.audit_person" :readonly="true" class="readO" style="width: 130px;"
                                  size="mini"></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[549]') }}</span>
                        <el-date-picker
                                v-model="formInline.invalid_date"
                                type="date"
                                value-format="yyyy-MM-dd"
                                :placeholder="$t('getapi[549]')"
                                :readonly="formInline.version_status == 1 && addoredit != 1"
                                :class="{'readO':formInline.version_status == 1 && addoredit != 1}"
                                style="width: 130px;"
                                size="mini"
                        ></el-date-picker>
                        <span>{{ $t('getapi[409]') }}</span>
                        <el-input v-model="formInline.create_time" class="readO" style="width: 130px;"
                                  size="mini"></el-input>

                        <span>{{ $t('getapi[734]') }}</span>
                        <el-input v-model="formInline.modify_time" class="readO" style="width: 130px;"
                                  size="mini"></el-input>

                        <span>{{ $t('getapi[732]') }}</span>
                        <el-input v-model="formInline.audit_time" class="readO" style="width: 130px;" size="mini"></el-input>
                    </div>

                    <div class="bbl">
                        <span>{{ $t('getapi[143]') }}</span>
                        <el-input type="textarea" v-model="formInline.remark" :placeholder="$t('getapi[143]')"
                                  style="width:800px;" size="mini"
                                  :readonly="formInline.version_status == 1 && addoredit != 1" :class="{'readO':formInline.version_status == 1 && addoredit != 1}"></el-input>
                    </div>
                </div>-->

                <el-row>
                    <el-col :span="24">
                        <div class="box">
                            <div>
                                <el-button type="primary" :disabled="formInline.version_status == 1 && addoredit != 1"
                                           size="mini" @click="addlines">{{ $t('getapi[6467]') }}
                                </el-button>
                                <!--<el-button type="primary" :disabled="formInline.version_status == 1 && addoredit != 1" size="mini" icon="el-icon-delete-solid" @click="dellines">删除</el-button>-->
                                <el-button type="primary" size="mini" @click="delnew" :disabled="formInline.version_status == 1">
                                    {{ $t('getapi[40]') }}
                                </el-button> 
                                <el-button type="primary" @click="copyinfo"  :disabled="formInline.version_status == 1 && addoredit != 1" size="mini" >{{ $t('getapi[12960]')}}</el-button>
                            </div>
                        </div>
                        <!-- <el-button type="primary" icon="el-icon-circle-plus" circle @click="addline"></el-button> -->
                        <u-table
                                v-cloak
                                :height="tableHeight - 200"
                                @selection-change="handleSelectionChange"
                                :row-class-name="tableRowClassNameRight"
                                :data="formInline.detail"
                                border
                                size="mini"
                                header-row-class-name="headerclass"
                                style="width: 100%;margin-top:3px"
                                :header-cell-style="$limits.headerClass"
                                id="xdetilpane-0"
                        >
                            <el-table-column type="selection" width="20"></el-table-column>
                            <el-table-column prop="routing_sequence" :label="$t('getapi[601]')" width="60">
                                <template slot-scope="scope">
                                    <el-input class="mcolor"
                                              :disabled="formInline.version_status == 1 && addoredit != 1 || !page.routing_sequence"
                                              v-model="scope.row.routing_sequence"
                                              @blur="changeSequence(scope)"
                                              @focus="$refs.SetBtn.SetOneBtnEnable('save', false)"
                                    ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="workproc_name" :label="$t('getapi[881]')" width="100">
                                <template slot-scope="scope">
                                    <routejump :urlNo="14" :calssType="1">
                                        <el-input
                                                v-model="scope.row.workproc_name"
                                                type="text"
                                                readonly
                                                size="mini"
                                                style="width:100%"
                                                class="mcolor"
                                                :disabled="formInline.version_status == 1 && addoredit != 1 || !page.workproc_name"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showrout(scope)" v-if="page.workproc_name"></i>
                                        </el-input>
                                    </routejump>
                                </template>
                            </el-table-column>
                            <el-table-column prop="workproc_description" :label="$t('getapi[603]')" width="100">
                                <template slot-scope="scope">
                                    <el-input class="mcolor"
                                              :disabled="formInline.version_status == 1 && addoredit != 1 || !page.workproc_description"
                                              v-model="scope.row.workproc_description"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="manhour_unit" :label="$t('getapi[580]')" width="70">
                                <template slot-scope="scope">
                                    <el-select filterable :disabled="formInline.version_status == 1 && addoredit != 1 || !page.manhour_unit"
                                               v-model="scope.row.manhour_unit" :placeholder="$t('getapi[580]')">
                                        <!-- 	<el-option label="时" value="时"></el-option> -->
                                        <el-option :label="$t('getapi[651]')" value="分"></el-option>
                                        <!-- <el-option label="秒" value="秒"></el-option> -->
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="workcenter_code" :label="$t('getapi[604]')" width="100">
                                <template slot-scope="scope">
                                    <routejump :urlNo="15" :calssType="1">
                                        <el-input
                                                v-model="scope.row.workcenter_code"
                                                type="text"
                                                readonly
                                                size="mini"
                                                style="width:100%"
                                                class="mcolor"
                                                :disabled="formInline.version_status == 1 && addoredit != 1 || !page.workcenter_code"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showwcenter(scope)" v-if="page.workcenter_code"></i>
                                        </el-input>
                                    </routejump>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="workcenter_name"
                                             :disabled="formInline.version_status == 1 && addoredit != 1 || !page.workcenter_name"
                                             :label="$t('getapi[585]')" width="60"></el-table-column>
                            <el-table-column prop="ready_manhour" :label="$t('getapi[577]')" width="60">
                                <template slot-scope="scope">
                                    <el-input type="number"
                                              autocomplete="off" title=""
                                              @mousewheel.native.prevent
                                              :disabled="formInline.version_status == 1 && addoredit != 1 && edithour || !page.ready_manhour"
                                              v-model="scope.row.ready_manhour"
                                              :placeholder="$t('getapi[577]')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="area" :label="$t('getapi[8421]')" width="60">
                                <template slot-scope="scope">
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.area"
                                              :placeholder="$t('getapi[139]')" :disabled="!page.area"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="key_flag" :label="$t('getapi[588]')" width="60">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.key_flag"
                                                 :disabled="editkeyflag || !page.key_flag"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column prop="running_manhour" :label="$t('getapi[578]')" width="60">
                                <template slot-scope="scope">
                                    <el-input type="number"
                                              autocomplete="off" title=""
                                              @mousewheel.native.prevent
                                              :disabled="formInline.version_status == 1 && addoredit != 1 && edithour || !page.running_manhour"
                                              v-model="scope.row.running_manhour"
                                              :placeholder="$t('getapi[578]')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="queue_manhour" :label="$t('getapi[579]')"
                                             width="60"></el-table-column>
                            <el-table-column prop="std_manhour" :label="$t('getapi[581]')" width="60">
                                <template slot-scope="scope" v-if="btn.workhour">
                                    <el-input type="number"
                                              autocomplete="off" title=""
                                              @mousewheel.native.prevent
                                              :disabled="formInline.version_status == 1 && addoredit != 1 && edithour || !page.std_manhour"
                                              v-model="scope.row.std_manhour"
                                              :placeholder="$t('getapi[581]')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="report_measure_method"
                                             :label="$t('getapi[606]')" width="60"></el-table-column>
                            <el-table-column prop="man_power" :label="$t('getapi[586]')">
                                <template slot-scope="scope" v-if="btn.workhour">
                                    <el-input type="number"
                                              autocomplete="off" title=""
                                              @mousewheel.native.prevent
                                              :disabled="formInline.version_status == 1 && addoredit != 1 && edithour || !page.man_power"
                                              v-model="scope.row.man_power" :placeholder="$t('getapi[586]')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="seq_flag" :label="$t('getapi[12859]')">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.seq_flag" :disabled="formInline.version_status == 1 || !page.seq_flag"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column prop="key_remark" :label="$t('getapi[8002]')" width="150">
                                <template slot-scope="scope">
                                    <el-input type="text" v-model="scope.row.key_remark" :disabled="!page.ready_manhour || !page.key_remark"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="routing_leadtime" :label="$t('getapi[8278]')" width="100" align="right"></el-table-column>
                            <el-table-column prop="Edit_Routing_leadtime" :label="$t('getapi[8279]')" width="120">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.Edit_Routing_leadtime" type="number" autocomplete="off" title="" @mousewheel.native.prevent :disabled="!page.Edit_Routing_leadtime"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="period_flag" :label="$t('getapi[12412]')">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.period_flag" :disabled="editperiod || !page.period_flag"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Period_hour" :label="$t('getapi[12413]')">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.Period_hour" type="number" autocomplete="off" title="" @mousewheel.native.prevent :disabled="editperiod || !page.Period_hour"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="group_name" :label="$t('getapi[12444]')" width="100px">
                                <template slot-scope="scope">
                                    <routejump :urlNo="10" :calssType="1">
                                        <el-input
                                                v-model="scope.row.group_name"
                                                type="text"
                                                readonly
                                                size="mini"
                                                style="width:100%"
                                                :disabled="!page.group_name"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectGroupName(scope)" v-if="page.group_name"></i>
                                        </el-input>
                                    </routejump>
                                </template>
                            </el-table-column>
                            <el-table-column prop="r_code" :label="$t('getapi[12445]')" width="100px">
                                <template slot-scope="scope">
                                    <routejump :urlNo="11" :calssType="1">
                                        <el-input
                                                v-model="scope.row.r_code"
                                                type="text"
                                                readonly
                                                size="mini"
                                                style="width:100%"
                                                :disabled="!page.r_code"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectRCode(scope)" v-if="page.r_code"></i>
                                        </el-input>
                                    </routejump>
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" align="center" :label="$t('getapi[6048]')">
                                <template slot-scope="scope">
                                    <el-button slot="reference" type="text" size="mini"
                                               @click.native.prevent="files(scope)">
                                        {{$t('getapi[3591]')}}
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="isprice" :label="$t('getapi[13434]')">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.isprice" :true-label="1" :false-label="0"  disabled></el-checkbox>
                                </template>
                            </el-table-column>
                        </u-table>
                        <!-- 数据展示 -->
                        <!-- <u-table :height="tableHeight - 292" :data="formInline.detail" header-row-class-name="headerclass" border size="mini" v-show="!editf">
                            <el-table-column show-overflow-tooltip prop="routing_sequence" :label="$t('getapi[601]')" align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="workcenter_code" :label="$t('getapi[604]')" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="workproc_description" :label="$t('getapi[603]')" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="manhour_unit" :label="$t('getapi[580]')" width="80"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[602]')" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="workcenter_name" :label="$t('getapi[585]')" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="ready_manhour" :label="$t('getapi[577]')" align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="area" :label="$t('getapi[139]') + 'd㎡'" align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="key_flag" :label="$t('getapi[588]')" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="running_manhour" :label="$t('getapi[578]')" align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="queue_manhour" :label="$t('getapi[579]')" align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="std_manhour" :label="$t('getapi[581]')" align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="report_measure_method" :label="$t('getapi[606]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="man_power" :label="$t('getapi[586]')" align="right"></el-table-column>
                        </u-table> -->
                    </el-col>
                </el-row>
            </li>
        </ul>
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="SelectIndexs"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="PageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <!-- 分页 -->
        <!-- 搜索弹框 -->
        <!-- <el-dialog :visible.sync="isVisible" :title="$t('getapi[3653]')" width="30%">
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('getapi[2020]')">
                    <u-table :data="queryData" border height="400" size="mini" style="width: 100%;">
                        <el-table-column show-overflow-tooltip prop="Field_Show_Name" :label="$t('getapi[2021]')" width="150"></el-table-column>
                        <el-table-column show-overflow-tooltip :label="$t('getapi[2022]')">
                            <template slot-scope="scope">
                                <input type="text" v-model="scope.row.query_Condition" style="border:none" />
                            </template>
                        </el-table-column>
                    </u-table>
                </el-tab-pane>
                <el-tab-pane :label="$t('getapi[2028]')"><div style="min-height: 400px; line-height: 30px;" v-html="hleptext"></div></el-tab-pane>
            </el-tabs>

            <span slot="footer" class="dialog-footer">
                <el-button @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
                <el-button type="primary" @click="intidata">{{ $t('getapi[1146]') }}</el-button>
            </span>
        </el-dialog> -->
        <!-- 关键工序检验注意事项 -->
        <el-dialog v-dialogDrag :visible.sync="isVisiblefile" :title="$t('getapi[3591]')" width="50%">
            <el-upload :show-file-list="false" class="upload-demo" 
                :data="fileparm" 
                :action="fileurl"
                :on-change="handleChange" 
                :on-success="handleSuccess">
                <el-button size="small" type="primary">{{$t('getapi[3591]')}}</el-button>
                <div slot="tip" class="el-upload__tip">{{$t('getapi[7961]')}}</div>
            </el-upload>
            <u-table :data="FileLists" border height="400" size="mini" style="width: 100%;"
                     :header-cell-style="$limits.headerClass">
                <el-table-column show-overflow-tooltip prop="Node_Name" :label="$t('getapi[3590]')" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Doc_Type" :label="$t('getapi[3605]')" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Doc_Size" :label="$t('getapi[7875]')" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Upload_Person" :label="$t('getapi[6425]')" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Upload_Time" :label="$t('getapi[6426]')" width="150"></el-table-column>
                <el-table-column fixed="right" align="center" :label="$t('getapi[6048]')">
                    <template slot-scope="scope">
                        <el-button slot="reference" type="text" size="small" @click.native.prevent="filedel(scope)">{{$t('getapi[40]')}}
                        </el-button>
                        <el-button slot="reference" type="text" size="small" @click.native.prevent="open(scope)">{{$t('getapi[3558]')}}
                        </el-button>
                    </template>
                </el-table-column>
            </u-table>

            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="isVisiblefile = false">{{ $t('getapi[6]') }}</el-button>
                <el-button type="primary" @click="intidata">{{ $t('getapi[1146]') }}</el-button>
            </span> -->
        </el-dialog>
        <!--<el-dialog :visible="isVisibleremark" title="关键工序检验注意试项" width="40%">
            <div>
                <el-input v-model="key_remark" type="textarea" size="mini" :close-on-click-modal="false"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="isVisibleremark = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="confirmChangeRemark">保 存</el-button>
            </span>
        </el-dialog>-->
        <el-dialog v-dialogDrag :visible.sync="isVisibleRouting" :title="$t('getapi[8003]')" width="25%"
                   :close-on-click-modal="false" @close='cancelTransferRouting'>
            <table>
                <tr>
                    <td>
                        <span>{{$t('getapi[8004]')}}：</span>
                    </td>
                    <td>
                        <el-input v-model="dataRouting.oldRouting" :disabled="true"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[8005]')}}：</span>
                    </td>
                    <td>
                        <el-select filterable v-model="dataRouting.selectRouting" size="mini" style="margin-righ:20px">
                            <el-option v-for="item in arrRouting" :key="item.Routing_Sequence"
                                       :label="item.Routing_Sequence"
                                       :value="item.Routing_Sequence"></el-option>
                        </el-select>
                    </td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="cancelTransferRouting">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmTransferRouting()" size="mini">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isVisibleSetRoutingRoad" :title="$t('getapi[7932]')" width="25%"
                   :close-on-click-modal="false">
            <table>
                <tr>
                    <td>
                        <span>{{$t('getapi[13054]')}}：</span>
                    </td>
                    <td>
                        <el-select filterable v-model="setroutingyear" size="mini" style="margin-righ:20px">
                            <el-option label="1" value="1"></el-option>
                            <el-option label="1~2" value="2"></el-option>
                            <el-option label="1~3" value="3"></el-option>
                            <el-option label="1~4" value="4"></el-option>
                            <el-option label="1~5" value="5"></el-option>
                        </el-select>
                    </td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isVisibleSetRoutingRoad = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmSetRoutingRoad()" size="mini">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>

        <serce :isVisible="isVisible" queryData="ENGROUTINGMASTERViewInfo" ref="ser" @getser="serclick"></serce>
        <!-- 搜索弹框 -->
        <!-- 物料弹框 -->
        <!-- <item :isVisible="itevisible" @getitem="gettitemd" ref="input"></item> -->
        <selector :isVisible="itevisible" :isSplitPage="true" :postUrl="'Eng/Parts/GetPartMasterPopupList'"
                  @callback="gettitemd" ref="input"></selector>
        <!-- 工序弹框 -->
        <!-- <rout :isVisible="rouvisible" @getrout="getrout" ref="routs"></rout> -->
        <selector :isVisible="rouvisible" :isSplitPage="true" :postUrl="'Basic/Items/GetRoutingTypePopupList'"
                  @callback="getrout" ref="routs"></selector>
        <!-- 工作中心弹框 -->
        <!-- <wcenter :isVisible="wcentervisible" @getwcenter="getwcenter" ref="rout"></wcenter> -->
        <selector :isVisible="wcentervisible" :isSplitPage="false" :postUrl="'Basic/Items/GetEngWorkCenterPopupList'"
                  @callback="getwcenter" ref="rout"></selector>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SchPro/GetGroupNamePopupList'" @callback="getGroupName" ref="groupname"></selector>
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SchPro/GetApsResourcePopupList'" @callback="getRCode" ref="rcode"></selector>
        <!-- 改变表格顺序 -->
        <ctable :isVisible="false" :title="$t('getapi[64]')" queryData="ENGROUTINGMASTERViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        
        <selector :isVisible="false" :isSplitPage=true :postUrl="'/Eng/Routings/GetCopyRoutingPopupList'"
                  @callback="getcopyrouting" ref="copyrouting"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import { Loading } from 'element-ui'
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'
    export default {
        name: 'carft',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            },
            tableH(){
                return  this.$windowSize.tableHeight3 - Common.reduceTableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                formInline: {
                    exclusively_id: '',
                    relation_partmaster_id: 0,
                    part_code: '',
                    part_name: '',
                    part_version: '',
                    effect_date: '',
                    invalid_date: '',
                    audit_person: '',
                    audit_time: '',
                    //version_status: '不可用',
                    routing_version: 'A0',
                    remark: '',
                    create_person: '',
                    create_time: '',
                    direct_stuff_move_flag: 0,
                    move_direction: '',
                    //enable_flag: '解冻',
                    modify_time: '',
                    modify_person: '',
                    tag_single: '',
                    tag_packag: '',
                    version_status: '0',
                    ce_flag:0,
                    enable_flag: false,
                    detail: []
                },
                oldFormInline: '',
                ids: '',
                showloading: '',
                isVisible: false,
                addoredit: 1,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('carft'),
                SelectIndex: 0,
                RightSelectIndex: 0, //右侧明细当前页面
                SelectIndexs: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                dataSetDetail: {}, // 编辑页面数据详情
                queryData: [], // 查询数组
                selectIDData: [], // 右侧选择的数据的ID集合
                selectDataview:[],
                selectData:[],
                tracetype: 0, //跟踪类别
                url: '', // 零件图路径
                isEdit: true, // 是否新增
                itevisible: false, //物料弹框
                ProPositionList: [],
                rouvisible: false,
                roushowindex: 0,
                rowindex:-1,
                wcentervisible: false,
                wcentershowindex: 0,
                //是否可以编辑
                editf: false,
                //工时费否可以编辑权限
                edithour: false,
                //关键工序是否可以编辑权限
                editkeyflag: false,
                //汇报时校是否可以编辑权限
                editperiod: false,
                currentRow: null,
                lineid: [],
                userData: [], //用户信息
                user: '', //当前用户
                btn: {
                    //明细行删除
                    rowdel: false,
                    //可用、不可用
                    available: false,
                    //冻结、解冻
                    frozen: false,
                    //冻结备注
                    frozenremark: false,
                    //工时修改
                    workhour: false,
                    // 刷新工艺路线
                    setroutingroad: false,
                    //设为无效
                    enablefalse:false,
                    //设为有效
                    enabletrue:false,
                },
                canmove: true, //可以流转
                isVisiblefile: false, //注意事项
                fileurl: '',
                fileparm: {
                    Code: '',
                    Data_Type: 8,
                    Login_Group:'',
                    Login_DB:'',
                },
                FileList: [],//注意事项文件
                FileLists: [], //注意事项文件
                oldrow: '',
                iscontinuedblclick: true,
                isVisibleRouting: false,
                arrRouting: [],
                dataRouting: {
                    oldRouting: '',
                    selectRouting: '', //选择的工序
                },
                editRowIndex: '', //记录修改工序号的行号
                sequenceeditordel: 1,//编辑工序：1  删除工序：2
                timeId: null,
                code: '',
                scrollTop:0,
                isVisibleSetRoutingRoad: false,//刷新工艺路线弹窗
                setroutingyear:1,
                page:{
                    direct_stuff_move_flag:true,
                    move_direction:true,
                    routing_sequence:true,
                    workproc_name:true,
                    workproc_description:true,
                    manhour_unit:true,
                    workcenter_code:true,
                    ready_manhour:true,
                    area:true,
                    key_flag:true,
                    running_manhour:true,
                    std_manhour:true,
                    man_power:true,
                    seq_flag:true,
                    key_remark:true,
                    Edit_Routing_leadtime:true,
                    period_flag:true,
                    Period_hour:true,
                    group_name:true,
                    r_code:true,
                },
            };
        },
        create() {
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == '2_srview' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    let arr = []
                    arr.push({
                        query_Condition: data.Part_Code,
                        query_field_name: "part_CODE",
                        query_field_type: "txt",
                        query_sort: "",
                        row_sign: 0
                    })
                    arr.push({
                        query_Condition: data.Part_version,
                        query_field_name: "part_version",
                        query_field_type: "txt",
                        query_sort: "",
                        row_sign: 0
                    })
                    arr.push({
                        query_Condition: '可用',
                        query_field_name: "version_status",
                        query_field_type: "txt",
                        query_sort: "",
                        row_sign: 0
                    })
                    let parm = {
                        PageIndex: vm.PageIndex,
                        PageSize: vm.PageSize,
                        SelectIndex: vm.SelectIndex,
                        Param: arr
                    };
                    vm.$http.urlpost('Eng/Routings/DataList', parm, function (res) {
                        if (res.Success == 1) {
                            vm.datajson = res.DataContent;
                            vm.total = res.Totals;
                            vm.DbTbNames = res.DbTbNames;
                            if (vm.datajson.length == 1) {
                                vm.getdlist(vm.datajson[0].Exclusively_Id, '', '')
                            }
                        }
                        vm.loading = false;
                    });
                    vm.$store.commit('clearSharedParams')
                }
                if(form.name == 'BOM' && Object.keys(vm.$store.state.sharedParams).length > 0){
                    const data = {...vm.$store.state.sharedParams};
                    vm.getdlist(data.id,'','')
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        beforeMount() {
            console.log('beforeMount');
            let that = this;

            //this.getqwlist();
            that.$http.urlpost('Eng/Routings/GetProPositionList', {}, function (res) {
                console.log(res);
                if (res.Success == 1) {
                    that.ProPositionList = res.DataContent;
                }
            });
        },
        mounted() {
            console.log('mounted');
            let that = this;
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
            that.$processdata.pushModelCache('carft', that);
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            let token = that.userData.token;
            // that.fileurl = Common.Url + 'Basic/UploadFilesResult?token=' + token;
            that.fileurl = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token;
            that.oldFormInline = JSON.stringify(that.formInline);
            that.confirmAdd();
            that.$limits.dragControllerDiv();
            //that.intidata();
            that.colsort();
            that.$nextTick(function () {
                that.$processdata.initForm()
                that.$processdata.initFormRight()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name);
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ENGROUTINGMASTERViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            files(e) {
                let that = this;
                console.log(e);
                this.FileLists = [];
                console.log("ceshi:"+e.row.exclusively_id)
                this.fileparm.Code = e.row.exclusively_id;
                this.FileList.forEach(item => {
                    if (item.Code == e.row.exclusively_id) {
                        this.FileLists.push(item);
                    }
                })
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
                this.isVisiblefile = true;
            },
            handleChange(file, fileList) {
                this.FileList = fileList.slice(-3);
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log('------handleSuccess---', res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.getdlist(that.formInline.exclusively_id, '', '');
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                }
            },
            //删除文件
            filedel(row) {
                let that = this;
                let index = row.$index;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8599]'), that.$t('getapi[194]'), {//此操作将永久删除该文件, 是否继续?
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let src = typeof row.row.FileSrc == 'undefined' ? '' : row.row.FileSrc;
                        let parm = {
                            ids: row.row.Node_ID,
                            FilesSrc: src
                        };
                        that.$http.urlpost('/Basic/DeleteFileByDocManageID', parm, res => {
                            if (res.Success == 1) {
                                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                                that.FileList.splice(index, 1);
                            }
                        });
                    })
                    .catch(() => {
                    });
            },
            //打开文件
            open(row) {
                let that = this;
                // if (!that.$limits.fnIsEmpty(row.row.path)) {
                //     window.open(Common.Url + row.row.path);
                // }
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.loading = true;
                that.userData = sessionStorage.getItem('userData');
                let parm = {
                    Login_Group: encryptDes(JSON.parse(that.userData).Login_Group,key),
                    Login_DB: encryptDes(JSON.parse(that.userData).Login_DB,key),
                    CType:row.row.ConfigType,
                    OthInfo:'',
                    NodeId:row.row.Node_ID,
                };
                console.log(parm);
                that.$http.urlfilepost(row.row.HttpPost,'/Files/GetFileUrl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl =res.DataContent;
                        window.open(hrefurl);
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.loading = false;
                });
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (!that.$limits.fnIsEmpty(that.formInline.exclusively_id)) {
                    if (that.formInline.version_status == '1') {
                        that.editf = true;
                    }
                    else {
                        that.editf = false;
                    }
                }
                else {
                    that.editf = false;
                }
                if (that.$limits.authority('plv4', 526, 1) > 0) {
                    //刷新工艺路线
                    that.btn.setroutingroad = true;
                }
                else {
                    that.btn.setroutingroad = false;
                }
                if (that.$limits.authority('plv4', 131, 1) > 0) {
                    //工时费否可以编辑权限
                    that.edithour = false;
                }
                else {
                    that.edithour = true;
                }
                if (that.$limits.authority('plv4', 584, 1) > 0) {
                    //关键工序
                    that.editkeyflag = false;
                }
                else {
                    that.editkeyflag = true;
                }
                if (that.$limits.authority('plv4', 585, 1) > 0) {
                    //汇报时效
                    that.editperiod = false;
                }
                else {
                    that.editperiod = true;
                }
                if (that.$limits.authority('plv2', 245, 1) == 1) {
                    that.$refs.SetBtn.SetOneBtnEnable('import', true);
                }
                else {
                    that.$refs.SetBtn.SetOneBtnEnable('import', false);
                }
                //管理界面
                if (that.$limits.authority('plv2', 28, 1) == 1) {
                    if (that.total > 0) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('refresh,search,export');
                    }
                    else {
                        that.$refs.SetBtn.SetButtonEnable('refresh,search');
                    }

                }
                else if (that.$limits.authority('plv2', 28, 1) == 2) {
                    //查询级
                    if (that.$limits.authority('plv3', 28, 1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('refresh,search,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 28, 1) == 1) {
                        //编辑级
                        if (!that.$limits.fnIsEmpty(that.formInline.exclusively_id)) {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }
                    if (that.$limits.authority('plv3', 28, 1) == 2) {
                        //删除级
                        if (!that.$limits.fnIsEmpty(that.formInline.exclusively_id)) {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }
                }
                else {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    if (that.$limits.authority('plv2', 27, 1) > 0) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                    }
                }
                if (that.$limits.authority('plv2', 245, 1) > 0) {
                    that.$refs.SetBtn.InputBtnRight('T03_RoutingMaster');
                }
                that.getpageauthority()
                that.btnauthority();
            },
            getpageauthority(){
                let that = this
                let arr = []
                arr.push({
                    query_Condition: 'craft',
                    query_field_name: "Page_Name",
                    query_field_type: "txt",
                    query_sort: "",
                    row_sign: 0
                },{
                    query_Condition: that.user,
                    query_field_name: "UserName",
                    query_field_type: "txt",
                    query_sort: "",
                    row_sign: 0
                })
                let parm = {
                    PageIndex: 1,
                    PageSize: 100000,
                    SelectIndex: 0,
                    Param: arr
                };
                that.$http.urlpost('/PageAuthl/GetSys_PageAuth_UserView', parm, function(res) {
                    if (res.Success == 1) {
                        if(res.DataContent.length != 0){
                            for(let i=0;i<res.DataContent.length;i++){
                                if(res.DataContent[i].AuthCode == 0){
                                    that.page[res.DataContent[i].Field_Name] = false
                                }
                            }
                        }
                    }
                });
            },
            btnauthority() {

                let that = this;
                //可用、不可用
                that.btn.available = false;
                //冻结、解冻
                that.btn.frozen = false;
                //冻结备注
                that.btn.frozenremark = false;
                if (that.$limits.authority('plv4', 137, 1) > 0) {
                    that.btn.frozen = true;
                }
                else {
                    that.btn.frozen = false;
                }

                if (that.$limits.authority('plv4', 138, 1) > 0) {
                    that.btn.frozenremark = true;
                }
                else {
                    that.btn.frozenremark = false;
                }
                if (that.$limits.authority('plv4', 5, 1) > 0) {
                    that.btn.available = true;
                }
                else {
                    that.btn.available = false;
                }
                that.btn.rowdel = false;
                if (that.selectIDData.length > 0) {
                    if (that.formInline.version_status == '0') {
                        that.btn.rowdel = true;
                    }
                }
                //工时修改
                that.btn.workhour = false
                if (that.$limits.authority('plv4', 131, 1) > 0) {
                    that.btn.workhour = true;
                }
            },
            tableRowClassNameRight({row, rowIndex}) {
                row.index = rowIndex;
            },
            //获取查询条件
            serclick(val) {
                console.log(val);
                this.queryData = val;
                this.PageIndex = 1;
                this.intidata();
            },
            sortclick(val) {
                if (val == 1) {
                    console.log('测试排序');
                    this.colsort();
                }
            },
            //物料弹框
            doTheThing() {
                console.log('物料弹框开启');
                this.itevisible = true;
                this.$refs.input.clearInput(this.itevisible);
            },
            //获取物料信息
            gettitemd(val) {
                this.formInline.relation_partmaster_id = val.exclusively_id;
                this.formInline.part_code = val.part_code;
                this.formInline.part_name = val.part_name;
                this.formInline.part_version = val.part_version;
                this.formInline.cargoposition_code = val.cargoposition_code;
                //this.$refs.input.clearInput(false);
            },
            //工序弹框
            showrout(row) {
                let that = this;
                if (that.editf) {
                    return;
                }
                this.rouvisible = true;
                this.roushowindex = row.$index;
                this.$refs.routs.clearInput(this.rouvisible);
                //this.addline(row.$index);
            },
            //获取工序信息
            getrout(val) {
                this.formInline.detail[this.roushowindex].workproc_id = val.exclusively_id;
                this.formInline.detail[this.roushowindex].workproc_code = val.workproc_code;
                this.formInline.detail[this.roushowindex].workproc_name = val.workproc_name;
            },
            //工作中心弹框
            showwcenter(row) {
                let that = this;
                if (that.editf) {
                    return;
                }
                this.wcentershowindex = row.$index;
                this.wcentervisible = true;
                this.$refs.rout.clearInput(this.wcentervisible);
            },
            //获取工作中心信息
            getwcenter(e) {
                this.formInline.detail[this.wcentershowindex].workcenter_id = e.exclusively_id;
                this.formInline.detail[this.wcentershowindex].workcenter_code = e.workcenter_code;
                this.formInline.detail[this.wcentershowindex].workcenter_name = e.workcenter_name;
                this.formInline.detail[this.wcentershowindex].queue_manhour = e.queue_time;
                this.formInline.detail[this.wcentershowindex].report_measure_method = e.report_measure_method;
                this.formInline.detail[this.wcentershowindex].key_flag = e.key_flag;
                this.formInline.detail[this.wcentershowindex].out_flag = e.out_flag;
            },
            selectGroupName(row){
                let that = this;
                that.rowindex = row.$index
                that.$refs.groupname.clearInput(true);
            },
            getGroupName(val){
                let that = this;
                that.formInline.detail[this.rowindex].r_code = ''
                that.formInline.detail[this.rowindex].group_name = val.group_name
            },
            selectRCode(row){
                let that = this;
                that.rowindex = row.$index
                that.$refs.rcode.clearInput(true);
            },
            getRCode(val){
                let that = this;
                console.log(val)
                that.formInline.detail[this.rowindex].group_name = val.group_name
                that.formInline.detail[this.rowindex].r_code = val.r_code
            },
            //删除行
            delline(e) {
                let line = e.$index;
                if (line > 0) {
                    this.formInline.detail.splice(line, 1);
                } else {
                    this.$message.error(this.$t('getapi[8710]'));//'移除失败'
                }
            },
            //新增一行工艺清单
            addline(line) {
                let that = this;
                that.formInline.detail[line].add = true;
                let detail = that.formInline.detail;
                let deti = {
                    add: false,
                    exclusively_id: '',
                    relation_id: 0,
                    workproc_id: 0,
                    workproc_code: '',
                    routing_sequence: 0,
                    workproc_name: '',
                    workproc_description: '',
                    manhour_unit: '分',
                    workcenter_id: 0,
                    workcenter_code: '',
                    workcenter_name: '',
                    parallel_flag: true,
                    routing_version: 'A0',
                    key_flag: false,
                    ready_manhour: 0,
                    running_manhour: 0,
                    std_manhour: 0,
                    queue_manhour: 0,
                    man_power: 0,
                    report_measure_method: '',
                    routing_relation_no: '',
                    out_flag: '',
                    area: 0,
                    area_edit: "",
                    key_remark: '',
                    routing_leadtime: '',
                    Edit_Routing_leadtime: '',
                    period_flag: false,
                    Period_hour: '',
                    group_name:'',
                    r_code:'',
                };
                let jss = detail[detail.length - 1].add;
                if (jss) {
                    that.formInline.detail.push(deti);
                }
            },
            linedelsel(e) {
                console.log(e);
                this.lineid = [];
                for (var i = 0; i < e.length; i++) {
                    this.lineid.push(e[i].linid);
                }
            },
            //批量删除
            dellines() {
                let that = this;
                let param = {
                    exclusively_id: that.formInline.exclusively_id,
                    details: []
                };
                for (let i = that.selectIDData.length - 1; i >= 0; i--) {
                    that.formInline.detail.splice(that.selectIDData[i].index, 1);
                    if (that.selectIDData[i].exclusively_id != '') {
                        let datatmp = {
                            exclusively_id: that.selectIDData[i].exclusively_id
                        };
                        param.details.push(datatmp);
                    }
                }
                if (param.details.length > 0) {
                    that.loading = true;
                    that.$http.urlpost('Eng/Routings/DelRoutingRow', param, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[284]'));
                            that.intidata();
                        }
                        that.getdlist(that.formInline.exclusively_id, '', '');
                        that.loading = false;
                    });
                }
            },
            
            copyinfo() {
                let that = this;
                let icount=0;
                if(that.formInline.detail.length>0){
                    for (let i =0;i< that.formInline.detail.length; i++) {
                        if (!that.$limits.fnIsEmpty(that.formInline.detail[i].exclusively_id)) {
                            if(that.formInline.detail[i].routing_sequence!=0){
                                icount=1;
                            }
                        }
                        // else if(that.formInline.detail[i].routing_sequence!=0){
                        //     console.log("测试："+that.formInline.detail[i].exclusively_id);
                        //     icount=1;
                        // }
                    }
                }
                if(icount<=0){
                    this.$refs.copyrouting.clearInput(true);
                }                
            },
            getcopyrouting(data) {
                let that = this;
                let parm = {
                    Id: data.exclusively_id
                };
                that.$http.urlpost('/Eng/Routings/GetCopyRoutingsInfoByID', parm, function (res) {
                    if (res.Success == 1) {
                        // let data = res.DataContent.listNextModel;
                        // that.iscopy=1;
                        that.formInline.detail = res.DataContent.Detail;
                    }
                });
            },
            // 删除 -- 标准工艺新增工序或删除工序的下挂物料变更
            delnew() {
                let that = this
                if(that.$limits.fnIsEmpty(that.formInline.exclusively_id)){
                    that.dellines()
                } else {
                    let arr = []
                    for(let i = 0;i<that.selectIDData.length;i++){
                        arr = [...arr,{
                            exclusively_id:   that.selectIDData[i].exclusively_id
                        }]
                    }
                    let parm = {
                        PartID: that.formInline.relation_partmaster_id,
                        RoutingVersion: that.formInline.routing_version,
                        ls: arr
                    }
                    that.$http.urlpost('/Eng/Routings/CheckExistPartDel', parm, function (res) {
                        if (res.Success == 1) {
                            if (res.DataContent == 0) {
                                that.dellines()
                            } else {
                                that.getRoutingSequenceDel()
                            }
                        }
                    });
                }
            },
            changeSequence(row) {
                let that = this
                if(that.$limits.fnIsEmpty(that.formInline.exclusively_id)){
                    that.$refs.SetBtn.SetOneBtnEnable('save', true)
                    return
                }
                if(row.row.Routing_Sequence_Old == row.row.routing_sequence){
                    that.$refs.SetBtn.SetOneBtnEnable('save', true)
                    return
                }
                let parm = {
                    "Exclusively_ID": row.row.exclusively_id,
                    "PartID": that.formInline.relation_partmaster_id,
                    "RoutingVersion": row.row.routing_version
                }
                that.$http.urlpost('/Eng/Routings/CheckExistPart', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent == 1){
                            that.editRowIndex = row.$index
                            that.getRoutingSequenceEdit(row.row)
                        } else {
                            that.$refs.SetBtn.SetOneBtnEnable('save', true)
                        }
                    }
                });
            },
            getRoutingSequenceEdit(row) {
                let that = this
                that.dataRouting.selectRouting = ''
                that.dataRouting.oldRouting = row.Routing_Sequence_Old
                let parm = {
                    Part_Id: that.formInline.relation_partmaster_id,
                    Routing_Version: that.formInline.routing_version,
                    Routing_Sequence_No: row.routing_sequence,
                    Routing_Sequence_No_Old: row.Routing_Sequence_Old
                }
                that.$http.urlpost('/Eng/Routings/getRoutingSequenceList', parm, function (res) {
                    if (res.Success == 1) {
                        that.arrRouting = res.DataContent
                        that.sequenceeditordel = 1
                        that.isVisibleRouting = true
                        that.$refs.SetBtn.SetOneBtnEnable('save', true)
                    }
                });
            },
            getRoutingSequenceDel(){
                let that = this
                that.dataRouting.selectRouting = ''
                let oldSequence = ''
                for(let i = 0;i<that.selectIDData.length;i++){
                    oldSequence = oldSequence + that.selectIDData[i].routing_sequence + ','
                }
                that.dataRouting.oldRouting = oldSequence.substring(0,oldSequence.length - 1)
                let parm = {
                    Part_Id: that.formInline.relation_partmaster_id,
                    Routing_Version: that.formInline.routing_version,
                    Routing_Sequence_No: '',
                    Routing_Sequence_No_Old: that.dataRouting.oldRouting
                }
                that.$http.urlpost('/Eng/Routings/getRoutingSequenceList', parm, function (res) {
                    if (res.Success == 1) {
                        that.arrRouting = res.DataContent
                        that.sequenceeditordel = 2
                        that.isVisibleRouting = true
                    }
                });
            },
            cancelTransferRouting() {
                let that = this
                if(that.sequenceeditordel == 1){
                    that.formInline.detail[that.editRowIndex].routing_sequence = that.formInline.detail[that.editRowIndex].Routing_Sequence_Old
                }
                that.isVisibleRouting = false
            },
            confirmTransferRouting() {
                let that = this
                if(that.dataRouting.selectRouting == ''){
                    that.$message.warning(that.$t('getapi[8592]'))//目标工序号不能为空！
                    return
                }
                let sequecnceno = ''
                let arr = []
                if(that.sequenceeditordel == 1){
                    sequecnceno = that.formInline.detail[that.editRowIndex].routing_sequence
                    for(let i = 0;i<that.formInline.detail.length;i++){
                        arr = [...arr,{
                            Exclusively_id: that.formInline.detail[i].exclusively_id,
                            Relation_Id: that.formInline.detail[i].relation_id,
                            WorkProc_id: that.formInline.detail[i].workproc_id,
                            READY_MANHOUR: that.formInline.detail[i].ready_manhour,
                            RUNNING_MANHOUR: that.formInline.detail[i].running_manhour,
                            QUEUE_MANHOUR: that.formInline.detail[i].queue_manhour,
                            Std_ManHour: that.formInline.detail[i].std_manhour,
                            MANHOUR_UNIT: that.formInline.detail[i].manhour_unit,
                            WORKCENTER_id: that.formInline.detail[i].workcenter_id,
                            MAN_POWER: that.formInline.detail[i].man_power,
                            PARALLEL_FLAG: that.formInline.detail[i].parallel_flag,
                            KEY_FLAG: that.formInline.detail[i].key_flag,
                            WORKPROC_Description: that.formInline.detail[i].workproc_description,
                            Routing_Relation_No: that.formInline.detail[i].routing_relation_no,
                            Routing_Sequence: that.formInline.detail[i].routing_sequence,
                            Area: that.formInline.detail[i].area,
                            Out_Flag: that.formInline.detail[i].out_flag,
                            remark: that.formInline.detail[i].key_remark
                        }]
                    }
                    let parm = {
                        Num: that.formInline.exclusively_id,
                        PartID: that.formInline.relation_partmaster_id,
                        Part_Code: that.formInline.part_code,
                        Part_Version: that.formInline.part_version,
                        RoutingVersion: that.formInline.routing_version,
                        Routing_Sequence_No: sequecnceno,
                        Routing_Sequence_No_Old: that.dataRouting.oldRouting,
                        Routing_Sequence_No_Dest: that.dataRouting.selectRouting,
                        EFFECT_DATE: that.formInline.effect_date,
                        INVALID_DATE: that.formInline.invalid_date,
                        Modify_Person: that.formInline.modify_person,
                        Direct_Stuff_Move_flag: that.formInline.direct_stuff_move_flag == true?1:0,
                        Move_Direction: that.formInline.move_direction,
                        Remark: that.formInline.remark,
                        Modify_Time: that.formInline.modify_time,
                        ls: arr
                    }
                    that.$http.urlpost('/Eng/Routings/ExecPartMove', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getdlist(that.formInline.exclusively_id, '', '');
                            that.isVisibleRouting = false
                        }
                    });
                } else {
                    for(let i = 0;i<that.selectIDData.length;i++){
                        arr = [...arr,{
                            Exclusively_id: that.selectIDData[i].exclusively_id,
                        }]
                    }
                    let parm = {
                        Num: that.formInline.exclusively_id,
                        PartID: that.formInline.relation_partmaster_id,
                        Part_Code: that.formInline.part_code,
                        Part_Version: that.formInline.part_version,
                        RoutingVersion: that.formInline.routing_version,
                        Routing_Sequence_No: sequecnceno,
                        Routing_Sequence_No_Old: that.dataRouting.oldRouting,
                        Routing_Sequence_No_Dest: that.dataRouting.selectRouting,
                        EFFECT_DATE: that.formInline.effect_date,
                        INVALID_DATE: that.formInline.invalid_date,
                        Modify_Person: that.formInline.modify_person,
                        Direct_Stuff_Move_flag: that.formInline.direct_stuff_move_flag == true?1:0,
                        Move_Direction: that.formInline.move_direction,
                        Remark: that.formInline.remark,
                        Modify_Time: that.formInline.modify_time,
                        ls: arr
                    }
                    that.$http.urlpost('/Eng/Routings/ExecMoveDel', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getdlist(that.formInline.exclusively_id, '', '');
                            that.isVisibleRouting = false
                        }
                    });
                }

            },
            // 新增s
            addlines() {
                let that = this;
                let dlength = that.formInline.detail.length;
                let detail = that.formInline.detail;
                let deti = {
                    exclusively_id: 0,
                    relation_id: that.formInline.exclusively_id,
                    workproc_id: 0,
                    workproc_code: '',
                    routing_sequence: 0,
                    workproc_name: '',
                    workproc_description: '',
                    manhour_unit: '分',
                    workcenter_id: 0,
                    workcenter_code: '',
                    workcenter_name: '',
                    parallel_flag: true,
                    routing_version: 'A0',
                    key_flag: false,
                    ready_manhour: 0,
                    running_manhour: 0,
                    std_manhour: 0,
                    queue_manhour: 0,
                    man_power: 0,
                    report_measure_method: '',
                    routing_relation_no: '',
                    out_flag: '',
                    area: 0,
                    routing_leadtime:0,
                    Edit_Routing_leadtime:0
                };

                that.formInline.detail.push(deti);
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('carft',val)
                this.intidata();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
            },
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                that.$http.urlpost('Eng/Routings/DataList', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                        that.$nextTick(function(){
                            that.$processdata.initForm(that.SelectIndex)
                        });
                    }
                    that.loading = false;
                });
            },
            //获取工艺清单
            getdlist(id, name, where) {
                let that = this;
                if (that.$limits.authority('plv2', 28, 1) < 1) {
                    return;
                }
                that.addoredit = 2
                let parm = {
                    Id: 0,
                    Code: id,
                    Name: name,
                    Where: where
                };
                that.FileList = [];
                that.FileLists = [];
                // console.log(parm);
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('Eng/Routings/GetRoutingsInfoByID', parm, function (res) {
                    if (res.Success == 1) {                        
                        that.FileList = res.DataContent.Attr;
                        that.FileList.forEach(item => {
                            if (item.Code == that.fileparm.Code) {
                                that.FileLists.push(item);
                            }
                        })
                        that.formInline = res.DataContent.Header[0];
                        that.formInline.ce_flag = that.formInline.ce_flag.toString();
                        (that.formInline.direct_stuff_move_flag = res.DataContent.Header[0].direct_stuff_move_flag == 1 ? true : false),
                            (that.formInline.version_status = res.DataContent.Header[0].version_status == 1 ? '1' : '0'),
                            (that.formInline.enable_flag = res.DataContent.Header[0].enable_flag);
                        that.formInline.detail = res.DataContent.Detail;

                        that.oldFormInline = JSON.stringify(that.formInline);
                    }
                    that.authority();
                    that.$nextTick(function(){
                        that.$processdata.initForm(this.SelectIndex)
                        that.$processdata.initFormRight(this.RightSelectIndex)
                    });
                    loadingInstance.close()
                });
            },

            GetCheckBoxClear() {
                let that = this;
            },
            PushCheckBoxClear() {
                let that = this;
                //string
                console.log(typeof that.formInline.direct_stuff_move_flag);
                //后端 要整型 1 或者 0 .后端要int ，前端上传 string 或者 bool 都会出错
                if (typeof that.formInline.direct_stuff_move_flag == 'string') {
                    that.formInline.direct_stuff_move_flag = that.formInline.direct_stuff_move_flag == '1' ? 1 : 0;
                    if (that.formInline.direct_stuff_move_flag === 0) that.formInline.move_direction = '';
                } else if (typeof that.formInline.direct_stuff_move_flag == 'boolean') {
                    that.formInline.direct_stuff_move_flag = that.formInline.direct_stuff_move_flag ? 1 : 0;
                    if (that.formInline.direct_stuff_move_flag == 0) that.formInline.move_direction = '';
                }
                that.formInline.version_status = parseInt(that.formInline.version_status);
                that.formInline.direct_stuff_move_flag = parseInt(that.formInline.direct_stuff_move_flag);
            },
            isRepeat(arr) {
                let hash = {};
                for (let i in arr) {
                    if (hash[arr[i]]) {
                        return true;
                    }
                    hash[arr[i]] = true;
                }
                return false;
            },
            // 保存数据
            save() {
                let that = this;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.PushCheckBoxClear();
                let parm = that.formInline;
                parm.LangType = that.$processdata.getLang()
                //工序号不能重复校验
                let arrtemp = [];
                for (let k = 0; k < parm.detail.length; k++) {
                    arrtemp.push(parm.detail[k].routing_sequence);
                }
                if (that.isRepeat(arrtemp)) {
                    that.$message.warning(that.$t('getapi[8593]'));//工序号不能重复！
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    return;
                }
                console.log(JSON.stringify(parm));
                that.loading = true;
                that.$http.urlpost('Eng/Routings/SaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata();
                        that.getdlist(res.UniqueNum, '', '');
                    } else if (res.Success == -1) {
                        //后台返-1
                        that.formInline.direct_stuff_move_flag = 0;
                        that.formInline.move_direction = '';
                    }
                    that.loading = false;
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                });
            },
            // 获取查询条件
            getqwlist() {
                let that = this;
                that.$http.urlpost('Eng/Routings/QWList', {}, function (res) {
                    that.queryData = res.DataContent;
                });
            },
            //行编辑
            edits(e) {
                let that = this;
                if(that.code == e.row.Exclusively_Id){
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.formInline;
                    for (let i = 0; i < datacopy.detail.length; i++) {
                        delete datacopy.detail[i]['index'];
                    }
                    if (that.oldFormInline != JSON.stringify(datacopy)) {
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = e.row
                                that.code = e.row.Exclusively_Id;
                                that.getdlist(that.code, '', '');
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = e.row
                        that.code = e.row.Exclusively_Id;
                        that.getdlist(that.code, '', '');
                    }
                }, 100);
            },
            // 编辑
            edit(jsd) {
                console.log(jsd);
                let that = this;
                let code = jsd.row.Exclusively_Id;
                that.getdlist(code, '', '');
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = val;
            },
            imp() {
                let item = {
                    //label: '工艺导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/3',
                    url: '/exp/3',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/3'});
                this.$store.commit('selectMenu', item);
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    ids: that.ids
                };
                console.log(parm);
                that.$http.urlpost('Basic/Items/DeleteItemByID', parm, function (res) {
                    that.intidata();
                    that.$message.success(that.$t('getapi[659]'));
                });
            },
            // 删除
            del(jsd) {
                this.ids = jsd.row.Exclusively_Id + ',';
                this.delf();
            },
            //批量删除
            delall() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//此操作将永久删除该数据, 是否继续?
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            movef(e) {
                let that = this;
                if (e == '1') {
                    that.formInline.direct_stuff_move_flag = '1';
                } else {
                    that.formInline.direct_stuff_move_flag = '0';
                    that.formInline.move_direction = '';
                }
            },
            //冻结解冻
            enable(e) {
                let that = this;
                if (that.formInline.part_code == '') return;
                let parm = {
                    Id: 0,
                    Code: that.formInline.exclusively_id,
                    Name: '',
                    Where: ''
                };
                if (e) {
                    //冻结
                    that.$http.urlpost('Eng/Routings/FrozenRoutingFlag', parm, res => {
                        if (res.Success == 1) {
                            //that.formInline.enable_flag = "0";
                            //that.formInlines.enable_flag = false;
                            that.$message.success(that.$t('getapi[1194]'));
                            that.getdlist(that.formInline.exclusively_id, '', '');
                        }
                    });
                } else {
                    //解冻
                    that.$http.urlpost('Eng/Routings/ThawRoutingFlag', parm, res => {
                        if (res.Success == 1) {
                            //that.formInline.enable_flag = "1"; //前后端 出入输出不一致
                            //that.formInlines.enable_flag = true;
                            that.$message.success(that.$t('getapi[1194]'));
                            that.getdlist(that.formInline.exclusively_id, '', '');
                        }
                    });
                }
            },
            // 可用/不可用
            status(e) {
                let that = this;
                if (that.formInline.part_code == '') return;
                let parm = {
                    partid: that.formInline.relation_partmaster_id,
                    routingid: that.formInline.exclusively_id,
                    routingversion: that.formInline.routing_version,
                    Isreplace: 0,
                    iscontinue: 0,
                    LangType: that.$processdata.getLang(),
                };
                if (e == '1') {
                    that.$http.urlpost('Eng/Routings/RoutingEnabledTrue', parm, res => {
                        if (res.Success == 1) {
                            that.formInline.version_status = '1'; //可用
                            //that.formInlines.version_status = true;
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getdlist(that.formInline.exclusively_id, '', ''); //刷左边
                        }
                        else if (res.Success == 2 || res.Success == 3) {
                            that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                                confirmButtonText: that.$t('getapi[1146]'),
                                cancelButtonText: that.$t('getapi[2054]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    parm.iscontinue = res.Success
                                    parm.Isreplace = 1
                                    that.$http.urlpost('Eng/Routings/RoutingEnabledTrue', parm, function (res1) {
                                        if (res1.Success == 1) {
                                            that.formInline.version_status = '1'; //可用
                                            that.$message.success(that.$processdata.explainCallbackMsg(res1.Msg));
                                            that.getdlist(that.formInline.exclusively_id, '', ''); //刷左边
                                        }
                                        else if (res1.Success == 3) {
                                            that.$confirm(that.$processdata.explainCallbackMsg(res1.Msg), that.$t('getapi[194]'), {
                                                confirmButtonText: that.$t('getapi[1146]'),
                                                cancelButtonText: that.$t('getapi[2054]'),
                                                type: 'warning'
                                            })
                                                .then(() => {
                                                    parm.iscontinue = res1.Success
                                                    parm.Isreplace = 1
                                                    that.$http.urlpost('Eng/Routings/RoutingEnabledTrue', parm, function (res3) {
                                                        if (res3.Success == 1) {
                                                            that.formInline.version_status = '1'; //可用
                                                            that.$message.success(that.$processdata.explainCallbackMsg(res3.Msg));
                                                            that.getdlist(that.formInline.exclusively_id, '', ''); //刷左边
                                                        }
                                                    })
                                                })
                                                .catch(() => {
                                                    that.getdlist(that.formInline.exclusively_id, '', '');
                                                });
                                        }
                                    })
                                })
                                .catch(() => {
                                    that.getdlist(that.formInline.exclusively_id, '', '');
                                });
                        }
                    });
                } else {
                    that.$http.urlpost('Eng/Routings/RoutingEnabledFalse', parm, res => {
                        if (res.Success == 1) {
                            that.formInline.version_status = '0'; //不可用
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getdlist(that.formInline.exclusively_id, '', '');
                        }
                        else if (res.Success == 2 || res.Success == 3) {
                            that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                                confirmButtonText: that.$t('getapi[1146]'),
                                cancelButtonText: that.$t('getapi[2054]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    parm.iscontinue = res.Success;
                                    that.$http.urlpost('Eng/Routings/RoutingEnabledFalse', parm, function (res1) {
                                        if (res1.Success == 1) {
                                            that.formInline.version_status = '0'; //不可用
                                            that.$message.success(that.$processdata.explainCallbackMsg(res1.Msg));
                                            that.getdlist(that.formInline.exclusively_id, '', '');
                                        }
                                        else if (res1.Success == 3) {
                                            that.$confirm(that.$processdata.explainCallbackMsg(res1.Msg), that.$t('getapi[194]'), {
                                                confirmButtonText: that.$t('getapi[1146]'),
                                                cancelButtonText: that.$t('getapi[2054]'),
                                                type: 'warning'
                                            })
                                                .then(() => {
                                                    parm.iscontinue = res1.Success;
                                                    that.$http.urlpost('Eng/Routings/RoutingEnabledFalse', parm, function (res2) {
                                                        if (res2.Success == 1) {
                                                            that.formInline.version_status = '0'; //不可用
                                                            that.$message.success(that.$processdata.explainCallbackMsg(res2.Msg));
                                                            that.getdlist(that.formInline.exclusively_id, '', '');
                                                        }
                                                    })
                                                })
                                                .catch(() => {
                                                    that.getdlist(that.formInline.exclusively_id, '', '');
                                                });
                                        }
                                    })
                                })
                                .catch(() => {
                                    that.getdlist(that.formInline.exclusively_id, '', '');
                                });
                        }
                    });
                }
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.formInline;
                for (let i = 0; i < datacopy.detail.length; i++) {
                    delete datacopy.detail[i]['index'];
                }
                if (that.oldFormInline != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//数据已发生变更，是否保存后新建？
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save();
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd();
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd();
                }
            },
            confirmAdd() {
                let that = this;
                let datetime = Common.methods.getDatetime();
                that.formInline = {
                    exclusively_id: '',
                    relation_partmaster_id: 0,
                    part_code: '',
                    part_name: '',
                    part_version: '',
                    effect_date: '',
                    invalid_date: '',
                    audit_person: '',
                    audit_time: '',
                    version_status: '0',
                    routing_version: 'A0',
                    remark: '',
                    create_person: that.user,
                    create_time: datetime,
                    direct_stuff_move_flag: 0,
                    move_direction: '',
                    enable_flag: false,
                    modify_time: '',
                    modify_person: '',
                    tool:'',
                    detail: [
                        {
                            exclusively_id: 0,
                            add: true,
                            relation_id: 0,
                            workproc_id: 0,
                            workproc_code: '',
                            routing_sequence: 0,
                            workproc_name: '',
                            workproc_description: '',
                            manhour_unit: '分',
                            workcenter_id: 0,
                            workcenter_code: '',
                            workcenter_name: '',
                            parallel_flag: true,
                            routing_version: 'A0',
                            key_flag: false,
                            ready_manhour: 0,
                            running_manhour: 0,
                            std_manhour: 0,
                            queue_manhour: 0,
                            man_power: 0,
                            report_measure_method: '',
                            routing_relation_no: '',
                            out_flag: '',
                            area: 0,
                            area_edit: "",
                            key_remark: '',
                            routing_leadtime: '',
                            Edit_Routing_leadtime: '',
                            period_flag: false,
                            Period_hour: '',
                            group_name:'',
                            r_code:'',
                        }
                    ]
                };
                that.addoredit = 1;
                that.code = ''
                that.oldFormInline = JSON.stringify(that.formInline);
                that.authority();
            },
            // 修改表格顺序
            opentable() {
                console.log('hello');
                this.$refs.ctab.clearInputs(true);
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'ENGROUTINGMASTERViewInfo');
            },
            // 刷新
            reflash() {
                /*let that = this;
                that.intidata(); //刷新左边
                //刷右边
                if (!that.$limits.fnIsEmpty(that.formInline.exclusively_id)) {
                    that.getdlist(that.formInline.exclusively_id, '', '');
                } else {
                    //清空右边
                    that.add();
                }*/
                let that = this;
                let datacopy = that.formInline;
                for (let i = 0; i < datacopy.detail.length; i++) {
                    delete datacopy.detail[i]['index'];
                }
                if (that.oldFormInline != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save();
                        })
                        .catch(() => {
                            that.intidata();
                            if (!that.$limits.fnIsEmpty(that.formInline.exclusively_id)) {
                                that.getdlist(that.formInline.exclusively_id, '', '');
                            } else {
                                //清空右边
                                that.confirmAdd();
                            }
                        });
                } else {
                    that.intidata();
                    if (!that.$limits.fnIsEmpty(that.formInline.exclusively_id)) {
                        that.getdlist(that.formInline.exclusively_id, '', '');
                    } else {
                        //清空右边
                        that.confirmAdd();
                    }
                }
            },
            //弹出框关闭前提示
            closemodel(e) {
                let that = this
                this.$confirm(that.$t('getapi[3655]'), that.$t('getapi[194]'), {//'数据已发生变更是否保存后关闭?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                    })
                    .catch(() => {
                    });
            },
            //导出·
            exp() {
                let that = this;
                that.showloading = that.openLoading();
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    //				if(item.query_Condition==''||item.query_Condition.length>0) {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                    //				}
                });
                console.log(JSON.stringify(parm));
                that.$http.urlpost('Eng/Routings/ListToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.showloading.close();
                });
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ENGROUTINGMASTERViewInfo",
                    fromname: that.$t('getapi[64]'),
                    SelectIndex: that.SelectIndex,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)*/
            },
            // 物料的工艺存在一个可用版本
            routingtwo() {
                let that = this;
                let parm = {
                    partid: that.formInline.part_code,
                    routingid: that.formInline.Exclusively_Id,
                    routingversion: that.formInline.routing_version
                };
                that.$http.urlpost('Eng/Routings/RoutingTwoEnabledTrue', parm, function (res) {
                    if (res.Success == 1) {
                        // that.$message.success();
                    }
                });
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = '100%';
                } else {
                    left[0].style.width = '100%';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            show(ev, row) {
                let that = this;
                that.edit(row);
            },
            shows(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = this.datajson[index - 1];
                    this.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = this.datajson[index + 1];
                    this.setCurrent(tds);
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                if (val != null) {
                    let result = this.datajson.findIndex(item => item.Exclusively_Id === val.Exclusively_Id);
                    this.indf = result;
                    let fsd = document.getElementsByClassName('fsd');
                    fsd[result].focus();
                    this.currentRow = val;
                }
            },
            // 刷新工艺路线
            setRoutingRoad(){
                let that = this
                that.isVisibleSetRoutingRoad = true
            },
            confirmSetRoutingRoad(){
                let that = this
                that.$confirm(that.$t('getapi[13055]'), that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let loadingInstance = Loading.service(Common.maskoption1);
                        let token = that.userData.token;
                        $.ajax({
                            url: Common.Url + '/Eng/Routings/SetRoutingRoad?token=' + token+'&year='+that.setroutingyear,
                            type: 'post',
                            contentType: 'application/json',
                            success: function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.isVisibleSetRoutingRoad = false
                                    that.intidata();
                                    loadingInstance.close()
                                } else {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                }
                            },
                            error: function (xhr, errorType, error) {
                                that.$message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                            }
                        });
                    })
                    .catch(() => {
                    });

            },
            checkDataChange() {
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 28,1) < 1){
                    return false
                }
                let datacopy = that.formInline;
                for (let i = 0; i < datacopy.detail.length; i++) {
                    delete datacopy.detail[i]['index'];
                }
                let flag = that.oldFormInline != JSON.stringify(datacopy);
                return flag;
            },
        }
    };
</script>

<style scoped lang="less">
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto 8px;
            white-space: pre;
            span {
                margin-left: 20px;
                min-width: 70px;
                text-align: left;
                line-height: 20px;
                margin-right: 5px;
            }
        }
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
        }
    }
</style>
